/* ==========================================================================
   Halloween FX — seasonal overlay for Corra Mart

   Props: faint corner webs, four spiders (three dangling, one walking the top
   edge), drifting bats, floating ghosts, a flying witch, blinking eyes in the
   corner, a flickering jack-o'-lantern, rising embers, and a moon that only
   appears on dark storefronts.

   Additive only: no existing markup, images or styles are modified.
   Remove by deleting the two halloween-fx includes from layout/theme.liquid.
   ========================================================================== */
(function () {
  'use strict';

  if (window.__hwFxLoaded) return;
  window.__hwFxLoaded = true;

  var NS = 'http://www.w3.org/2000/svg';

  function el(tag, attrs) {
    var n = document.createElementNS(NS, tag);
    for (var k in attrs) if (attrs.hasOwnProperty(k)) n.setAttribute(k, attrs[k]);
    return n;
  }

  function svgRoot(viewBox) {
    return el('svg', { viewBox: viewBox, 'aria-hidden': 'true', focusable: 'false' });
  }

  function div(cls) {
    var d = document.createElement('div');
    if (cls) d.className = cls;
    return d;
  }

  /* ---- read the page's own background so props sit on it correctly ------- */

  function parseRGB(str) {
    var m = String(str).match(/rgba?\(([^)]+)\)/);
    if (!m) return null;
    var p = m[1].split(',').map(function (n) { return parseFloat(n); });
    if (p.length >= 4 && p[3] === 0) return null; // transparent, keep looking
    return { r: p[0], g: p[1], b: p[2] };
  }

  function pageBackground() {
    var candidates = [document.body, document.documentElement];
    for (var i = 0; i < candidates.length; i++) {
      if (!candidates[i]) continue;
      var rgb = parseRGB(getComputedStyle(candidates[i]).backgroundColor);
      if (rgb) return rgb;
    }
    return { r: 255, g: 255, b: 255 };
  }

  function luminance(c) {
    return (0.2126 * c.r + 0.7152 * c.g + 0.0722 * c.b) / 255;
  }

  var BG = pageBackground();
  var isDark = luminance(BG) < 0.5;
  var BG_CSS = 'rgb(' + Math.round(BG.r) + ',' + Math.round(BG.g) + ',' + Math.round(BG.b) + ')';
  document.documentElement.setAttribute('data-hw-dark', isDark ? '1' : '0');

  var LINE = isDark ? 'rgba(255,255,255,0.46)' : 'rgba(38,26,48,0.32)';
  var LINE_SOFT = isDark ? 'rgba(255,255,255,0.24)' : 'rgba(38,26,48,0.16)';
  // Bats and the witch read as shapes against the page, so they follow INK
  // rather than a true black silhouette (which vanishes on a dark storefront).
  var INK = isDark ? '#EDE6F7' : '#2B1B3D';
  var GHOST = isDark ? 'rgba(255,255,255,0.92)' : 'rgba(122,102,152,0.85)';

  /* ---- quarter web anchored in a corner ---------------------------------- */

  function buildWeb(size, rings, spokes) {
    var svg = svgRoot('0 0 ' + size + ' ' + size);
    var g = el('g', { fill: 'none', 'stroke-linecap': 'round' });
    var angles = [], i, j;

    for (i = 0; i <= spokes; i++) angles.push((Math.PI / 2) * (i / spokes));

    for (i = 0; i < angles.length; i++) {
      g.appendChild(el('line', {
        x1: 0, y1: 0,
        x2: (Math.cos(angles[i]) * size).toFixed(2),
        y2: (Math.sin(angles[i]) * size).toFixed(2),
        stroke: LINE, 'stroke-width': '0.75'
      }));
    }

    for (j = 1; j <= rings; j++) {
      var r = (size / (rings + 0.35)) * j, d = '';
      for (i = 0; i < angles.length - 1; i++) {
        var a1 = angles[i], a2 = angles[i + 1], mid = (a1 + a2) / 2, sag = r * 0.82;
        var x1 = Math.cos(a1) * r, y1 = Math.sin(a1) * r;
        var x2 = Math.cos(a2) * r, y2 = Math.sin(a2) * r;
        var cx = Math.cos(mid) * sag, cy = Math.sin(mid) * sag;
        if (i === 0) d += 'M' + x1.toFixed(2) + ',' + y1.toFixed(2);
        d += ' Q' + cx.toFixed(2) + ',' + cy.toFixed(2) + ' ' + x2.toFixed(2) + ',' + y2.toFixed(2);
      }
      g.appendChild(el('path', { d: d, stroke: j % 2 ? LINE : LINE_SOFT, 'stroke-width': '0.65' }));
    }

    svg.appendChild(g);
    return svg;
  }

  /* ---- spider ------------------------------------------------------------ */

  function buildSpider(eyeColor) {
    var svg = svgRoot('0 0 40 40');
    var legs = el('g', {
      fill: 'none', stroke: INK, 'stroke-width': '1.7', 'stroke-linecap': 'round'
    });
    [
      'M16,20 C10,17 7,19 4,14', 'M16,22 C10,21 6,23 3,20',
      'M16,24 C10,25 7,28 4,29', 'M17,26 C13,29 12,32 10,35',
      'M24,20 C30,17 33,19 36,14', 'M24,22 C30,21 34,23 37,20',
      'M24,24 C30,25 33,28 36,29', 'M23,26 C27,29 28,32 30,35'
    ].forEach(function (d) { legs.appendChild(el('path', { d: d })); });
    svg.appendChild(legs);

    svg.appendChild(el('ellipse', { cx: 20, cy: 23, rx: 7.5, ry: 8.5, fill: INK }));
    svg.appendChild(el('circle', { cx: 20, cy: 14, r: 4.6, fill: INK }));
    [[18.3, 13.2], [21.7, 13.2]].forEach(function (p) {
      svg.appendChild(el('circle', { cx: p[0], cy: p[1], r: 1.25, fill: eyeColor || '#FF8A18' }));
    });
    return svg;
  }

  /* ---- bat --------------------------------------------------------------- */

  function buildBat() {
    var svg = svgRoot('0 0 68 40');
    var g = el('g', { fill: INK, 'class': 'hw-bat__wing' });
    g.appendChild(el('path', {
      d: 'M34,14 C29,6 21,3 13,7 C15,11 12,13 6,12 C11,19 12,25 10,31 ' +
         'C16,26 24,25 29,30 C31,26 32,20 34,14 Z ' +
         'M34,14 C39,6 47,3 55,7 C53,11 56,13 62,12 C57,19 56,25 58,31 ' +
         'C52,26 44,25 39,30 C37,26 36,20 34,14 Z'
    }));
    svg.appendChild(g);
    svg.appendChild(el('ellipse', { cx: 34, cy: 19, rx: 4.2, ry: 8, fill: INK }));
    svg.appendChild(el('path', {
      d: 'M31,12 L29.5,5 L33,9.5 Z M37,12 L38.5,5 L35,9.5 Z', fill: INK
    }));
    return svg;
  }

  /* ---- ghost ------------------------------------------------------------- */

  function buildGhost() {
    var svg = svgRoot('0 0 30 38');
    svg.appendChild(el('path', {
      d: 'M15,1 C7.8,1 3,6.4 3,13.6 L3,33.5 C3,35 4.6,35.6 5.6,34.5 ' +
         'L8,31.8 L10.8,34.6 C11.5,35.3 12.5,35.3 13.2,34.6 L15,32.7 ' +
         'L16.8,34.6 C17.5,35.3 18.5,35.3 19.2,34.6 L22,31.8 ' +
         'L24.4,34.5 C25.4,35.6 27,35 27,33.5 L27,13.6 C27,6.4 22.2,1 15,1 Z',
      fill: GHOST
    }));
    svg.appendChild(el('ellipse', { cx: 10.6, cy: 14, rx: 1.9, ry: 2.5, fill: '#2B1B3D' }));
    svg.appendChild(el('ellipse', { cx: 19.4, cy: 14, rx: 1.9, ry: 2.5, fill: '#2B1B3D' }));
    svg.appendChild(el('ellipse', { cx: 15, cy: 21.5, rx: 2.2, ry: 2.8, fill: '#2B1B3D' }));
    return svg;
  }

  /* ---- witch on a broom -------------------------------------------------- */

  function buildWitch() {
    var svg = svgRoot('0 0 96 62');
    var g = el('g', { fill: INK });

    // broomstick and bristles
    g.appendChild(el('path', { d: 'M10,44 L74,32 L74,35.4 L10,47.4 Z' }));
    g.appendChild(el('path', {
      d: 'M74,30 L94,24 L92,31 L95,32.6 L90,36 L92,40 L84,39.6 L74,37.4 Z'
    }));

    // figure: cloak, head, hat
    g.appendChild(el('path', {
      d: 'M40,36 C36,32 34,25 38,20 C42,15 50,15 53,20 ' +
         'C56,25 55,31 51,35 C58,36 62,40 60,45 ' +
         'C52,44 44,42 38,44 C36,41 37,38 40,36 Z'
    }));
    g.appendChild(el('circle', { cx: 46.5, cy: 15.5, r: 5.4 }));
    g.appendChild(el('path', { d: 'M36,12 L58,12 L52,10.6 L47,1 L42,10 Z' }));

    // trailing arm to the broom
    g.appendChild(el('path', {
      d: 'M52,24 C58,25 64,28 68,32', fill: 'none',
      stroke: INK, 'stroke-width': '3', 'stroke-linecap': 'round'
    }));

    svg.appendChild(g);
    return svg;
  }

  /* ---- moon -------------------------------------------------------------- */

  function buildMoon() {
    var svg = svgRoot('0 0 74 74');
    svg.appendChild(el('circle', { cx: 37, cy: 37, r: 33, fill: '#FDF3D0' }));
    var craters = el('g', { fill: '#E8DCB4' });
    [[27, 28, 6.5], [47, 24, 4.2], [44, 46, 7.4], [25, 49, 4.8], [56, 38, 3.2]]
      .forEach(function (c) {
        craters.appendChild(el('circle', { cx: c[0], cy: c[1], r: c[2] }));
      });
    svg.appendChild(craters);
    return svg;
  }

  /* ---- blinking eyes ----------------------------------------------------- */

  function buildEyes() {
    var svg = svgRoot('0 0 54 22');

    [[14, 11], [40, 11]].forEach(function (p, i) {
      svg.appendChild(el('ellipse', {
        cx: p[0], cy: p[1], rx: 11, ry: 8.4, fill: '#FFC93C'
      }));
      svg.appendChild(el('ellipse', {
        cx: p[0], cy: p[1], rx: 3.1, ry: 7.4, fill: '#2B1B3D'
      }));
      // lid closes over the eye on the blink keyframe
      var lid = el('rect', {
        x: p[0] - 12, y: 0, width: 24, height: 22,
        fill: BG_CSS,
        'class': 'hw-eyes__lid' + (i ? ' hw-eyes__lid--r' : '')
      });
      svg.appendChild(lid);
    });

    return svg;
  }

  /* ---- jack-o'-lantern --------------------------------------------------- */

  function buildPumpkin() {
    var svg = svgRoot('0 0 44 44');

    svg.appendChild(el('path', {
      d: 'M22,10 C22,7 21,4.5 19.5,3', fill: 'none',
      stroke: '#4B7A32', 'stroke-width': '2.6', 'stroke-linecap': 'round'
    }));
    svg.appendChild(el('path', {
      d: 'M23,9 C26,6.5 29.5,6 31,7.5', fill: 'none',
      stroke: '#5C9440', 'stroke-width': '2', 'stroke-linecap': 'round'
    }));

    var body = el('g', {});
    body.appendChild(el('ellipse', { cx: 22, cy: 27, rx: 17, ry: 15, fill: '#E8720C' }));
    body.appendChild(el('ellipse', { cx: 22, cy: 27, rx: 11, ry: 15, fill: '#F58A1F' }));
    body.appendChild(el('ellipse', { cx: 22, cy: 27, rx: 4.5, ry: 15, fill: '#FF9D33' }));
    svg.appendChild(body);

    var face = el('g', { fill: '#FFE9A8', 'class': 'hw-pumpkin__face' });
    face.appendChild(el('path', { d: 'M13,23 L19,26 L13,28 Z' }));
    face.appendChild(el('path', { d: 'M31,23 L25,26 L31,28 Z' }));
    face.appendChild(el('path', { d: 'M22,27.5 L24.6,31 L19.4,31 Z' }));
    face.appendChild(el('path', {
      d: 'M13.5,34 L16,36.2 L18.5,34 L21,36.2 L23.5,34 L26,36.2 L28.5,34 ' +
         'L28.5,36.6 L26,38.4 L23.5,36.6 L21,38.4 L18.5,36.6 L16,38.4 L13.5,36.6 Z'
    }));
    svg.appendChild(face);

    return svg;
  }

  /* ---- assemble ---------------------------------------------------------- */

  function dangler(variant) {
    var s = div('hw-spider hw-spider--' + variant);
    s.appendChild(div('hw-spider__thread'));
    var b = div('hw-spider__body');
    b.appendChild(buildSpider(variant === 'b' ? '#E4443C' : '#FF8A18'));
    s.appendChild(b);
    return s;
  }

  function mount() {
    if (document.getElementById('hw-fx')) return;

    var root = div();
    root.id = 'hw-fx';
    root.setAttribute('aria-hidden', 'true');
    root.style.setProperty('--hw-line', LINE);

    root.appendChild(div('hw-vignette'));

    // moon only makes sense against a dark storefront
    if (isDark) {
      var moon = div('hw-moon');
      moon.appendChild(div('hw-moon__halo'));
      moon.appendChild(buildMoon());
      root.appendChild(moon);
    }

    // corner webs
    [['tl', 8, 6], ['tr', 8, 6], ['br', 6, 5], ['bl', 6, 5]].forEach(function (cfg) {
      var web = div('hw-web hw-web--' + cfg[0]);
      web.appendChild(buildWeb(100, cfg[1], cfg[2]));
      root.appendChild(web);
    });

    // three dangling spiders
    ['a', 'b', 'c'].forEach(function (v) { root.appendChild(dangler(v)); });

    // one walking the top edge
    var crawler = div('hw-crawler');
    var crawlInner = div('hw-crawler__inner');
    crawlInner.appendChild(buildSpider('#FF8A18'));
    crawler.appendChild(crawlInner);
    root.appendChild(crawler);

    // bats
    for (var i = 1; i <= 3; i++) {
      var bat = div('hw-bat hw-bat--' + i);
      bat.appendChild(buildBat());
      root.appendChild(bat);
    }

    // witch
    var witch = div('hw-witch');
    witch.appendChild(buildWitch());
    root.appendChild(witch);

    // ghosts
    ['hw-ghost', 'hw-ghost hw-ghost--2'].forEach(function (cls) {
      var g = div(cls);
      g.appendChild(buildGhost());
      root.appendChild(g);
    });

    // eyes peering from the corner
    var eyes = div('hw-eyes');
    eyes.appendChild(buildEyes());
    root.appendChild(eyes);

    // jack-o'-lantern
    var pumpkin = div('hw-pumpkin');
    pumpkin.appendChild(div('hw-pumpkin__glow'));
    pumpkin.appendChild(buildPumpkin());
    root.appendChild(pumpkin);

    // embers
    for (var e = 0; e < 9; e++) {
      var ember = div('hw-ember');
      ember.style.left = (5 + e * 4.6 + Math.random() * 4).toFixed(1) + '%';
      ember.style.animationDuration = (16 + Math.random() * 14).toFixed(1) + 's';
      ember.style.animationDelay = '-' + (Math.random() * 26).toFixed(1) + 's';
      root.appendChild(ember);
    }

    document.body.appendChild(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mount, { once: true });
  } else {
    mount();
  }
})();
